import { render, staticRenderFns } from "./PaymentMethodItem.vue?vue&type=template&id=7540a852&"
import script from "./PaymentMethodItem.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodItem.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports